import { render, staticRenderFns } from "./cadmunicipios.vue?vue&type=template&id=d2842bc8&"
import script from "./cadmunicipios.vue?vue&type=script&lang=js&"
export * from "./cadmunicipios.vue?vue&type=script&lang=js&"
import style0 from "./cadmunicipios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports